import React, { useEffect, useState } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import AiAgent from './AiAgent';
import AiAppBar from './AiAppBar';
import AiPreview from './AiPreview';
import AiSidebar from './AiSidebar';
import ExercisePreview from './ExercisePreview';
import NotFound from './NotFound';
import { AiProvider } from './context/AiContext';
import CircuitFormView from './views/CircuitFormView';
import CircuitsView from './views/CircuitsView';
import ExerciseFormView from './views/ExerciseFormView';
import ExercisesView from './views/ExercisesView';
import WorkoutFormView from './views/WorkoutFormView';
import WorkoutPlansView from './views/WorkoutPlansView';
import WorkoutsView from './views/WorkoutsView';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor: '#212121',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    borderBottom: '1px solid #303030',
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    marginTop: 0,
    height: '100%',
    backgroundColor: '#181818',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#181818',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    marginBottom: '10px',
    justifyContent: 'flex-end',
  },
}));

const AiStudio = () => {
  const { path } = useRouteMatch();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(() => !isMobile);

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <AiProvider>
        <CssBaseline />
        <AiAppBar classes={classes} open={open} handleDrawerOpen={handleDrawerOpen} isMobile={isMobile} />
        <AiSidebar classes={classes} open={open} handleDrawerClose={handleDrawerClose} isMobile={isMobile} />
        {/* Main Content Area */}
        <Switch>
          <Route exact path={`${path}/`} render={props => <AiAgent {...props} open={open} />} />
          <Route path={`${path}/chat/:id`} render={props => <AiAgent {...props} open={open} />} />
          <Route path={`${path}/preview/training-plan`} render={props => <AiPreview {...props} open={open} />} />
          <Route path={`${path}/preview/workout`} render={props => <AiPreview {...props} open={open} />} />
          <Route path={`${path}/preview/excercise`} render={props => <ExercisePreview {...props} open={open} />} />
          <Route path={`${path}/workout-plans`} render={props => <WorkoutPlansView {...props} open={open} />} />
          <Route path={`${path}/exercises/create`} render={props => <ExerciseFormView {...props} open={open} />} />
          <Route path={`${path}/exercises`} render={props => <ExercisesView {...props} open={open} />} />
          <Route path={`${path}/workouts/create`} render={props => <WorkoutFormView {...props} open={open} />} />
          <Route path={`${path}/workouts`} render={props => <WorkoutsView {...props} open={open} />} />
          <Route path={`${path}/circuits/create`} render={props => <CircuitFormView {...props} open={open} />} />
          <Route path={`${path}/circuits`} render={props => <CircuitsView {...props} open={open} />} />
          <Route component={NotFound} />
        </Switch>
      </AiProvider>
    </div>
  );
};

export default AiStudio;
